var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIbeifyInIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6266 10.3335C11.6265 10.6871 11.4858 11.0262 11.2356 11.2761C10.9855 11.526 10.6462 11.6664 10.2926 11.6662C9.93901 11.666 9.59994 11.5254 9.35001 11.2752C9.10009 11.025 8.95978 10.6858 8.95996 10.3322C8.96014 9.97856 9.10078 9.63949 9.35096 9.38956C9.60113 9.13964 9.94034 8.99934 10.294 8.99951C10.6476 8.99969 10.9867 9.14033 11.2366 9.39051C11.4865 9.64068 11.6268 9.97989 11.6266 10.3335ZM11.6666 12.6535H8.99996V21.0002H11.6666V12.6535ZM15.88 12.6535H13.2266V21.0002H15.8533V16.6202C15.8533 14.1802 19.0333 13.9535 19.0333 16.6202V21.0002H21.6666V15.7135C21.6666 11.6002 16.96 11.7535 15.8533 13.7735L15.88 12.6535Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbeifyInIcon);
export default __webpack_public_path__ + "static/media/ibeify_in_icon.c226d2caebd0ec72355b7ecbccd5363f.svg";
export { ForwardRef as ReactComponent };